import {
  DefaultEntityFilters,
  EntityAutocompletePicker
} from '@backstage/plugin-catalog-react'
import { EntityLibraryTypeFilter } from './EntityComponentsFilter'

type CombinedFilters = DefaultEntityFilters & {
  libraryType: EntityLibraryTypeFilter
}

export type EntityLibraryTypePickerProps = {
  showCounts?: boolean
}

export function EntityLibraryTypePicker(props: EntityLibraryTypePickerProps) {
  return (
    <EntityAutocompletePicker<CombinedFilters>
      label="Library Type"
      name="libraryType"
      path="metadata.annotations.sennder.com/library-type"
      Filter={EntityLibraryTypeFilter}
      showCounts={props.showCounts}
    />
  )
}
